module.exports = __webpack_public_path__ + "img/logo-with-slogan.b9828961.png";